/**
 * Detects whether a mouse event landed in a scrollbar gutter rather than on content.
 *
 * Clicking a scrollbar fires a `mousedown` whose `target` is the scrolling element itself, which
 * click-outside handlers then read as "the user clicked somewhere else" and use to close popups.
 * See VSCO-3839.
 */
export function isScrollbarClick(event: MouseEvent): boolean {
    const element = event.target;
    if (!(element instanceof Element)) return false;

    // Window scrollbar: documentElement.clientWidth/clientHeight exclude it.
    const documentElement = document.documentElement;
    if (event.clientX > documentElement.clientWidth || event.clientY > documentElement.clientHeight) {
        return true;
    }

    // Element scrollbar: offsetX/offsetY are relative to the target's padding edge, and
    // clientWidth/clientHeight exclude the scrollbar gutter. The scroll checks matter — without
    // them any click past the content box of a non-scrolling element would count as a scrollbar.
    const hasVerticalScrollbar = element.scrollHeight > element.clientHeight;
    const hasHorizontalScrollbar = element.scrollWidth > element.clientWidth;

    return (
        (hasVerticalScrollbar && event.offsetX > element.clientWidth) ||
        (hasHorizontalScrollbar && event.offsetY > element.clientHeight)
    );
}
